// NOTE: Dependencies: jQuery, defiant

(function ($) {
	$.fn.lmPredictiveSearch = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			activeClass: 'header-map--active',
			loaderClass: 'home-search-panel__field--loader',
			$predictiveInput: $('#predictiveInput'),
			$predictiveOutput: $('#predictiveOutput'),
			$searchForm: $('#locationSearchForm'),
			latArea: '',
			lngArea: '',
			mapSearchRadius: 0.3,
			predictive: false,
			predictiveAmount: 10,
			$body: $('body')
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.country = settings.$body.data('country');
			$.fn.lmGlobal.checkPlatform(settings);
		}

		// Toggle Active Classes
		methods.toggle = function ($context) {
			$context.toggleClass(settings.activeClass);
		}

		// Bind events
		methods.events = function($context) {
			var timer;

			// Event for predictive text on input
			settings.$predictiveInput.off('input.lmPredictiveSearch').on('input.lmPredictiveSearch', function(event) {
				event.preventDefault();

				// Setting global value to be used in multiple functions
				settings.searchValue = this.value;

				// Only runs above 4 characters and on non touch devices as keyboard will probably get in way of predictive panel
				// Leaving commented to test on all devices
				if (settings.searchValue.length > 3 && $('html').hasClass('no-touchevents')) {
				// if (settings.searchValue.length > 4) {

					// Add loader
					settings.$predictiveInput.parent().addClass(settings.loaderClass);

					// Setting to true on input event so can populate results and differentiate between predictive and normal post form search functions
					settings.predictive = true;

					// Timer used for delay on predictive search so ajax calls aren't running continuously
					clearTimeout(timer);
					timer = setTimeout(function() {
						methods.ajaxCheck(settings);
					}, 500);
				}

				// Clear panel when ajax isn't called but user is still typing
				if (settings.searchValue.length < 4 && $('html').hasClass('no-touchevents')) {
					settings.$predictiveOutput.html('');
					settings.$predictiveInput.parent().removeClass(settings.loaderClass);
				}
			});

			// Form submit function
			settings.$searchForm.off('submit.lmPredictiveSearch').on('submit.lmPredictiveSearch', function(event) {
				event.preventDefault();

				// Setting to false so can run normal post search functions
				settings.predictive = false;
				settings.searchValue = settings.$predictiveInput.val();
				$.fn.lmGlobal.ajaxCheck(settings);
			});
		}

		// Fallback fuction when result from internal IMO JSON is not found. Uses google geocoding to find a lat and long based on what user is typing.
		// TODO. Url below on ajax call needs changing to internal BED handler Url when they've done it.
		// Needs to be BED driven as google geocoding API needs to be locked to one IP (server IP) and also has a low limit of calls allowed for free so cannot be showing API key in console.
		methods.searchMapApi = function($context) {
			settings.searchValue = settings.searchValue.trim().replace(' ', '+');

			// Setting query string values to pass to google geocoding API
			var	data = {
				address: settings.searchValue,
				country: settings.country
			}

			$.ajax({
				type: 'GET',
				dataType: 'json',
				data: data,
				url: settings.googleGeoCodeUrl,
				success: function(data, textStatus, jqXHR) {
					if (data.results[0]) {

						// Finding lat and long from search result from google geocoding API. Then creating a radius to search.
						var latArea = data.results[0].geometry.location.lat,
								lngArea = data.results[0].geometry.location.lng,
								latLowRange = latArea - settings.mapSearchRadius,
								latHighRange = latArea + settings.mapSearchRadius,
								lngLowRange = lngArea - settings.mapSearchRadius,
								lngHighRange = lngArea + settings.mapSearchRadius;

						//console.log('Predictive Search ' + settings.mapSearchRadius);

						// Searching the JSON for a radius.
						settings.locationResults = defiant.json.search(settings.dataSnapShot, "//*[Latitude > " + latLowRange + " and Latitude < " + latHighRange + " and Longitude > " + lngLowRange + " and Longitude < " + lngHighRange +"]");

						// If predictive search load predictive panel. Else submit form.
						methods.searchLocation($context);

					} else {

						// Remove loader
						settings.$predictiveInput.parent().removeClass(settings.loaderClass);
					}
				}
			});
		}

		methods.captilise = function(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}

		methods.searchJson = function($context) {

			// Search IMO JSON address node based on user input

			settings.locationResults = defiant.json.search(settings.dataSnapShot, '//*[City="'+ settings.searchValue.toUpperCase() +'"]');

			if (!settings.locationResults.length) {
				settings.searchValue = methods.captilise(settings.searchValue);
				settings.locationResults = defiant.json.search(settings.dataSnapShot, '//*[Name="'+ settings.searchValue +'"]');
			}

			if (!settings.locationResults.length) {
				settings.locationResults = defiant.json.search(settings.dataSnapShot, "//*[contains(City, '"+ settings.searchValue +"')]");
			}

			if (!settings.locationResults.length) {
				settings.locationResults = defiant.json.search(settings.dataSnapShot, "//*[contains(Name, '"+ settings.searchValue +"')]");
			}

			// If no result. Query google maps geocoding API.
			if (settings.locationResults.length == 0) {
				methods.searchMapApi($context);
			} else {

				// If predictive search load predictive panel. Else submit form.
				methods.searchLocation($context);
			}
		}

		methods.ajaxCheck = function($context) {

			var countryQuery = {country: settings.country};

			// Initial ajax call. Only calls once. Else uses stored variable snapshot using defiant JS.
			if (!settings.dataSnapShot) {
				$.ajax({
					type: 'GET',
					dataType: 'json',
					data: countryQuery,
					url: settings.locationJsonUrl,
					success: function(data, textStatus, jqXHR) {
						settings.dataSnapShot = defiant.getSnapshot(data.Markers);
						methods.searchJson($context);
					},
				  error: function(XMLHttpRequest, textStatus, errorThrown) {
						// TODO error handling
					}
				});
			} else {
				methods.searchJson($context);
			}
		}

		methods.searchLocation = function($context) {

			if (settings.predictive) {

				// Show location data in dropdown panel.
				methods.displayLocationList($context);
			} else {
				// Else submit form.
				$.fn.lmGlobal.searchSubmit(settings);
			}
		}

		methods.displayLocationList = function($context) {

			// Reset html
			var html = '',
					count = '';

			// Setting loop amount based on length of result.
			if (settings.locationResults.length < settings.predictiveAmount) {
				count = settings.locationResults.length;
			} else {
				count = settings.predictiveAmount;
			}

			// Loop and set HTML.
			if (settings.locationResults.length) {
				for (var i = 1; i <= count; i++) {
					html += '<a href="'+ settings.domain + settings.locationResults[i-1].Url +'" class="home-search-panel__predictive-output-item">'+ settings.locationResults[i-1].Name +'</a>';
				}
			}

			// Output the results.
			settings.$predictiveOutput.html(html);

			// Remove loader
			settings.$predictiveInput.parent().removeClass(settings.loaderClass);
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	if($('.home-search-panel').length) {
		$('.home-search-panel').lmPredictiveSearch();
	}

}(jQuery));
